import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {FreightServiceAddState} from "@/interfaces/state";
import {FreightServiceAdd} from "@/interfaces/entity";
import {
    createFreightServiceAdd, deleteFreightServiceAdd,
    listFreightServiceAdd,
    singleFreightServiceAdd,
    updateFreightServiceAdd
} from "@/modules/freightserviceadds/services";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {FreightServiceAddParams} from "@/modules/freightserviceadds/params";
import { union } from 'lodash';

@Module({ dynamic: true, name: "freightServiceAdd", store })
class FreightServiceAddModule extends VuexModule implements FreightServiceAddState {
    data: IdMapper<FreightServiceAdd> = {};
    ids: string[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: FreightServiceAddParams = new FreightServiceAddParams();
    
    @Mutation
    private UPDATE_FREIGHT_SERVICE_ADD_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation
    private MAP_FREIGHT_SERVICE_ADD(payload: any) {
        const idMapper: IdMapper<FreightServiceAdd> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((service: FreightServiceAdd, index: number) => {
            idMapper[service.rowGuid!] = {
                ...service,
                isDeleting: false,
                stt: index + 1
            };
            return service.rowGuid;
        });
        this.data = idMapper;
    }

    @Mutation
    private SET_FREIGHT_SERVICE_ADD(payload: FreightServiceAdd) {
        this.ids = union(this.ids, [payload.rowGuid]);
        this.data[payload?.rowGuid] = {...payload, isDeleting: false}
    }

    @Mutation
    private DELETE_FREIGHT_SERVICE_ADD(payload: FreightServiceAdd) {
        if (!this.data[payload.rowGuid] || !this.ids.includes(payload.rowGuid)) return;
        this.ids = this.ids.filter((id: string) => id !== payload.rowGuid);
        delete this.data[payload.rowGuid];
    }

    @Mutation
    private START_DELETE_FREIGHT_SERVICE_ADD(id: string) {
        this.data[id].isDeleting = true;
    }

    @Mutation
    private END_DELETE_FREIGHT_SERVICE_ADD(id: string) {
        this.data[id].isDeleting = false;
    }

    @Action({ rawError: true })
    public addFreightServiceAdd(payload: FreightServiceAdd) {
        this.SET_FREIGHT_SERVICE_ADD(payload);
    }

    @Action({ rawError: true })
    public async createFreightServiceAdd(form: any) {
        const { data } = await createFreightServiceAdd(form);
        this.SET_FREIGHT_SERVICE_ADD(data.data);
    }

    @Action({ rawError: true })
    public async listFreightServiceAdd(params: FreightServiceAddParams = new FreightServiceAddParams()) {
        const { data } = await listFreightServiceAdd(params);
        this.MAP_FREIGHT_SERVICE_ADD(data);
        return data.datas;
    }

    @Action({ rawError: true })
    public async singleFreightServiceAdd(id: string) {
        const { data } = await singleFreightServiceAdd(id);
        return data.data;
    }

    @Action({ rawError: true })
    public async updateFreightServiceAdd(dataReq: any) {
        const { data } = await updateFreightServiceAdd(dataReq.rowGuid, dataReq);
        this.SET_FREIGHT_SERVICE_ADD(data.data);
    }

    @Action({ rawError: true })
    public async deleteFreightServiceAdd(id: string) {
        this.START_DELETE_FREIGHT_SERVICE_ADD(id);
        const { data } = await deleteFreightServiceAdd(id);
        this.END_DELETE_FREIGHT_SERVICE_ADD(id);
        this.DELETE_FREIGHT_SERVICE_ADD(data.data);
    }

    @Action({ rawError: true })
    public updateFreightServiceAddParams(payload: any) {
        this.UPDATE_FREIGHT_SERVICE_ADD_PARAMS(payload);
    }
}

export const FreightServiceAddStore = getModule(FreightServiceAddModule);